export var PyJobRequestType;
(function (PyJobRequestType) {
    PyJobRequestType["UNKNOWN"] = "unknown";
    PyJobRequestType["CALCULATION"] = "calculation";
    PyJobRequestType["CALCULATION_ML"] = "calculation_ml";
    PyJobRequestType["SAMPLE"] = "sample";
    PyJobRequestType["IMPORT"] = "import";
    PyJobRequestType["RUN"] = "run";
    PyJobRequestType["RUN_ML"] = "run_ml";
    PyJobRequestType["DOWNLOAD"] = "download";
    PyJobRequestType["EXPORT"] = "export";
    PyJobRequestType["MATCH"] = "match";
    PyJobRequestType["DATA_PROFILE"] = "data_profile";
    PyJobRequestType["INFERENCE"] = "inference";
    PyJobRequestType["MONITORING"] = "monitoring";
    PyJobRequestType["LOCK"] = "lock";
    PyJobRequestType["UNIT_TEST"] = "unit_test";
    PyJobRequestType["RESTORE"] = "restore";
    PyJobRequestType["INCENTIVES_DATA_PROCESSING"] = "incentives_data_processing";
})(PyJobRequestType || (PyJobRequestType = {}));
export const MULTI_PROGRESS_JOB_TYPES = [PyJobRequestType.LOCK];
//# sourceMappingURL=pyJobRequestType.js.map